<template>
    <div>
        <v-dialog v-model="kpiitemdialog" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"
           >+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline mb-4">{{$t('pmkpiset.addkpiitem')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                    <v-row v-if="!isEdit">
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('pmkpiset.selectkpiitem')"
                                type="text"
                                ref="pmkpiitemid"
                                v-model="selections.pmkpiitemid"
                                @input="updateValue"
                                @change="changeKPIItem(selections.pmkpiitemid)"
                                dense
                                :items="KPIItemsList"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('pmkpiitem.kpitype')"
                                type="text"
                                ref="pmkpitype"
                                readonly
                                background-color="#ffeab2"
                                v-model="selections.pmkpitype"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="selections.pmkpitypeid === 2">
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.description')"
                                type="text"
                                ref="description"
                                v-model="selections.description"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="11" sm="11" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('performancemanagement.goal')"
                                type="text"
                                ref="goal"
                                background-color="#ffeab2"
                                readonly
                                :rules="[rules.required]"
                                v-model="selections.goal"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="11" sm="11" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('performancemanagement.kpi')"
                                type="text"
                                ref="kpi"
                                background-color="#ffeab2"
                                readonly
                                :rules="[rules.required]"
                                v-model="selections.kpi"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="5" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('performancemanagement.targetoption')"
                                type="text"
                                ref="pmtargetoptionid"
                                v-model="selections.targetoption"
                                dense
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="5" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                type="text"
                                ref="pmcalmethodid"
                                v-model="selections.calmethod"
                                background-color="#ffeab2"
                                readonly
                                dense
                                @input="updateValue"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" class="mx-0">
                            <v-row>
                                <v-col v-if="selections.targetoption == 'Target, threshold, stretch'" cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.defaultthreshold')"
                                        type="number"
                                        v-model="selections.threshold"
                                        ref="threshold"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.defaulttarget')"
                                        type="number"
                                        v-model="selections.target"
                                        ref="target"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="selections.targetoption == 'Target, threshold, stretch'" cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.defaultstretch')"
                                        type="number"
                                        v-model="selections.stretch"
                                        ref="stretch"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.defaultweightage')"
                                        type="number"
                                        v-model="selections.weightage"
                                        ref="weightage"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.subperiodcount')"
                                        type="number"
                                        v-model="selections.subperiodcount"
                                        ref="subperiodcount"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                        :rules="[rules.required, rules.positiveInteger]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiitem.kpifinalscorecalmethod')"
                                        type="text"
                                        ref="pmkpifinalscorecalmethod"
                                        v-model="selections.pmkpifinalscorecalmethod"
                                        dense
                                        background-color="#ffeab2"
                                        readonly
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="7" sm="7" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmkpiitem.kpicategory')"
                                type="text"
                                ref="pmkpicatname"
                                v-model="selections.pmkpicatname"
                                dense
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.pmkpicatcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-checkbox
                                v-model="selections.changeWeightage"
                                :label="$t('pmkpiset.canchangeweightage')"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-checkbox
                                v-model="selections.changeTarget"
                                :label="$t('pmkpiset.canchangetarget')"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-checkbox
                                v-model="selections.changeSubperiodcount"
                                :label="$t('pmkpiset.canchangesubperiodcount')"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row> -->
                </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeKPIItemInput">{{$t('button.cancel')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveKPIItemInput">{{$t('button.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>

        </v-data-table>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       // 'app-genericform': GenericForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                positiveInteger: value => {
                    const pattern = /^[1-9]\d*$/;
                    return pattern.test(value) || this.$t('reportsparam.nonnegativeInteger');
                },
            },

            kpiitemdialog: false,
            editDialog: false,
            detailItem: this.parentObject.detailItem,
         
            selections: {
                pmkpisetid: this.parentObject.kpisetid,
                pmkpiitemid: null,
                pmkpitypeid: null,
                pmkpitype: null,
                description: null,
                goal: null,
                kpi: null,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                targetoption: null,
                calmethod: null,
                threshold: null,
                target: null,
                stretch: null,
                weightage: null,
                subperiodcount: null,
                changeWeightage: false,
                changeTarget: false,
                changeSubperiodcount: false,
                pmkpifinalscorecalmethod: null, //only add ID if the field is editable in the future (same goes to pmkpicat)
                pmkpicatname: null,
                pmkpicatcode: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            KPIItemsList: [],
            KPIItemsFull: [],

            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
            isEdit: false,
        }
    },

    methods: {
        compareArray,

        loadKPIItems() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiitem/individual' })
                .then((res) => {

                    const existingIds = vm.detailItem.map(item => item.pmkpiitemid);
                    const filteredRec = res.data.rec.filter(item => !existingIds.includes(item.id));
                    vm.KPIItemsFull = filteredRec;
                    for (let i = 0; i < filteredRec.length; i++) {
                        vm.KPIItemsList.push({
                            text: filteredRec[i].goal,
                            value: filteredRec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.response.data.message;
                });
        },

        changeKPIItem(id) {
            let item = this.KPIItemsFull.find((item) => item.id === id);
            this.selections.pmkpiitemid = item.id;
            this.selections.pmkpitypeid = item.pmkpitypeid;
            this.selections.pmkpitype = item.pmkpitype;
            this.selections.description = item.description;
            this.selections.goal = item.goal;
            this.selections.kpi = item.kpi;
            this.selections.pmtargetoptionid = item.pmtargetoptionid;
            this.selections.targetoption = item.targetoption;
            this.selections.pmcalmethodid = item.pmcalmethodid;
            this.selections.calmethod = item.calmethod;
            this.selections.threshold = item.threshold;
            this.selections.target = item.target;
            this.selections.stretch = item.stretch;
            this.selections.weightage = item.weightage;
            this.selections.subperiodcount = item.subperiodcount;
            this.selections.pmkpifinalscorecalmethod = item.pmkpifinalscorecalmethod;
            this.selections.pmkpicatname = item.pmkpicatname;
            this.selections.pmkpicatcode = item.pmkpicatcode;
            this.updateValue();
        },

      
        modifyItemHandler(item) {

            Object.keys(item).forEach(key => {
                this.$set(this.selections, key, item[key]);
            });

            this.isEdit = true; // set editing mode
            this.kpiitemdialog = true;
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!confirm(this.$t('pmkpiset.confirmdeleteitem'))) {
                return;
            }

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            this.$store.dispatch('delete', {url: "/kpisetd/" + item.id + "/" + this.$store.getters.userId})
            .then((res) => {
            if (res.data.error) {
                vm.isErr = !vm.isErr;
                vm.errMsg = res.data.error;
                this.resetSelections();

            } else {
                let itemIndex = this.detailItem.indexOf(item);
                this.detailItem.splice(itemIndex, 1);
            }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        saveKPIItemInput() {
            const vm = this;

            if (this.isEdit) {// Update existing item

                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }
                this.$store.dispatch('put', {url: "/kpisetd/" + this.selections.id, payload: this.selections})
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                    this.resetSelections();

                } else {
                    const convertedItem = {
                        ...this.selections,
                        changeWeightageText: this.selections.changeWeightage == 1 ? 'Y' : 'N',
                        changeTargetText: this.selections.changeTarget == 1 ? 'Y' : 'N',
                        changeSubperiodcountText: this.selections.changeSubperiodcount == 1 ? 'Y' : 'N',
                    };

                    // Update the existing item in detailItem
                    const index = this.detailItem.findIndex(item => item.id === this.selections.id);
                    if (index !== -1) {
                        this.$set(this.detailItem, index, convertedItem);
                    }

                    this.kpiitemdialog = false;
                    this.resetSelections();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });

            } else {// Create new item
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }
                this.$store.dispatch('post', {url: "/kpisetd/create", payload: this.selections})
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                    this.resetSelections();

                } else {
                    const convertedItem = {
                        ...this.selections,
                        id: res.data.id,
                        changeWeightageText: this.selections.changeWeightage == 1 ? 'Y' : 'N',
                        changeTargetText: this.selections.changeTarget == 1 ? 'Y' : 'N',
                        changeSubperiodcountText: this.selections.changeSubperiodcount == 1 ? 'Y' : 'N',
                    };

                    this.detailItem.push(convertedItem);

                    this.kpiitemdialog = false;
                    this.resetSelections();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
            
        },

        updateValue() {
            this.$emit('input', {
                pmkpisetid: this.parentObject.kpisetid,
                pmkpiitemid: this.selections[0].pmkpiitemid,
                pmkpitypeid: this.selections[0].pmkpitypeid,
                pmkpitype: this.selections[0].pmkpitype,
                description: this.selections[0].description,
                goal: this.selections[0].goal,
                kpi: this.selections[0].kpi,
                pmtargetoptionid: this.selections[0].pmtargetoptionid,
                targetoption: this.selections[0].targetoption,
                pmcalmethodid: this.selections[0].pmcalmethodid,
                calmethod: this.selections[0].calmethod,
                threshold: this.selections[0].threshold,
                target: this.selections[0].target,
                stretch: this.selections[0].stretch,
                weightage: this.selections[0].weightage,
                subperiodcount: this.selections[0].subperiodcount,
                changeWeightage: this.selections[0].changeWeightage,
                changeTarget: this.selections[0].changeTarget,
                changeSubperiodcount: this.selections[0].changeSubperiodcount,
                pmkpifinalscorecalmethod: this.selections[0].pmkpifinalscorecalmethod,
                pmkpicatname: this.selections[0].pmkpicatname,
                pmkpicatcode: this.selections[0].pmkpicatcode,
                stamp: 0, // reset stamp to 0
                userid: this.$store.getters.userId
            });
        },

        closeKPIItemInput() {
            this.kpiitemdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.selections = {
                pmkpisetid: this.parentObject.kpisetid,
                pmkpiitemid: null,
                pmkpitypeid: null,
                pmkpitype: null,
                description: null,
                goal: null,
                kpi: null,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                targetoption: null,
                calmethod: null,
                threshold: null,
                target: null,
                stretch: null,
                weightage: null,
                subperiodcount: null,
                changeWeightage: false,
                changeTarget: false,
                changeSubperiodcount: false,
                pmkpifinalscorecalmethod: null, //only add ID if the field is editable in the future (same goes to pmkpicat)
                pmkpicatname: null,
                pmkpicatcode: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },          
    },

    mounted() {
        this.loadKPIItems();
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>